import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-stylized-checkbox',
  standalone: true,
  
  templateUrl: './stylized-checkbox.component.html',
  styleUrl: './stylized-checkbox.component.scss'
})
export class StylizedCheckboxComponent {
  @Input() selected: boolean = false; // Estado inicial del checkbox
  @Output() toggle: EventEmitter<boolean> = new EventEmitter<boolean>(); // Evento de salida

  onToggle(): void {
    this.selected = !this.selected; // Alterna el estado seleccionado
    this.toggle.emit(this.selected); // Emite el nuevo estado
  }
}
